import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { AuthService, CmsService, RoutingService, UrlPipe, TranslatePipe } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subject, Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { KnBrCustomerContextService } from '../../store/kn-br-customer-context/kn-br-customer-context.service';
import { CustomerData } from './../../models/customer.model';
import { KnBrSidebarService } from './../../services/kn-br-sidebar.service';
import { OutletRefDirective, GlobalMessageComponent, PageLayoutComponent, PageSlotComponent } from '@spartacus/storefront';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { RemoveLeadingZerosPipe } from '../../shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';
import { Auth0Service } from 'src/app/services/knbr-new-auth0.service';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';

@Component({
    selector: 'kn-br-outlet',
    templateUrl: './kn-br-outlet.component.html',
    styleUrls: ['./kn-br-outlet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [OutletRefDirective, GlobalMessageComponent, PageLayoutComponent, PageSlotComponent, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, RouterLink, AsyncPipe, UrlPipe, TranslatePipe, RemoveLeadingZerosPipe]
})
export class KnBrOutletComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  isHeaderHidden = false;
  customerContext$: Observable<CustomerData> = this.customerContextService.get$;
  isLoggedIn$: Observable<boolean> = this.authService.isUserLoggedIn();
  user$ = this.userService.get();
  subscription = new Subscription();
  private destory$ = new Subject<void>();
  pageTemplateName = '';
  readonly isLoginPage$ = this.cmsService
    .getCurrentPage()
    .pipe(
      map(
        (page) =>
          page &&
          (page.template === 'KnBrLoginPageTemplate' ||
            page.template === 'knBrQuoteSellerApproverTemplate' ||
            page.template === 'SSOPageTemplate')
      )
    );
  readonly isUndefinedPage$ = this.cmsService
    .getCurrentPage()
    .pipe(
      map(
        (page) =>
          !page || page.template === 'knBrQuoteSellerApproverTemplate' || page.template === 'ContentPage1Template'
      )
    );
  readonly hideBreadCrumb$ = this.cmsService
    .getCurrentPage()
    .pipe(
      map(
        (page) =>
          page &&
          (page.template === 'KnBrSearchResultsListPageTemplate' ||
            page.template === 'KnBrProductListPageTemplate' ||
            page.template === 'KnBrProductGridPageTemplate' ||
            page.template === 'KnBrSearchResultsGridPageTemplate' ||
            page.template === 'SalesLandingPage2Template' ||
            page.template === 'KnBrProductDetailsPageTemplate')
      )
    );
  readonly isNacPage$ = this.cmsService
    .getCurrentPage()
    .pipe(map((page) => !page || page.template === 'NACPageTemplate'));
  readonly isStaticPage$ = this.cmsService
    .getCurrentPage()
    .pipe(map((page) => page && page.template === 'ContentPage1Template'));

  constructor(
    private cmsService: CmsService,
    private customerContextService: KnBrCustomerContextService,
    private userService: UserAccountFacade,
    private sidebarService: KnBrSidebarService,
    private authService: AuthService,
    private routingService: RoutingService,
    private newAuth0Service: Auth0Service,
    private knBrCommonService: KnBrCommonService
  ) {
    this.subscription.add(
      this.cmsService.getCurrentPage().subscribe((page) => {
        if (page) {
          this.pageTemplateName = page.template;
        }
      })
    );
  }

  ngOnInit(): void {
        this.subscription.add(
      this.isLoggedIn$.subscribe((res) => {
        if (res) {
            this.knBrCommonService.getRedirectionDetail().pipe(takeUntil(this.destory$)).subscribe({
              next: (redirect) => {
              },
              error: (error) => {
                console.error('Error occurred while fetching redirection detail:', error);
                this.logout();
              }
            });
        }
      })
    );
}
  removeCustomerContext() {
    if (
      this.pageTemplateName === 'KnBrDraftOrderPageTemplate' ||
      this.pageTemplateName === 'KnBrQuotePageTemplate' ||
      this.pageTemplateName === 'KnBrOrderHistoryPageTemplate' ||
      this.pageTemplateName === 'KnBrReturnHistoryPageTemplate' ||
      this.pageTemplateName === 'KnBrFactSheetPageTemplate' ||
      this.pageTemplateName === 'CarlisleShippingListingPageTemplate' ||
      this.pageTemplateName === 'KnBrInvoiceListPageTemplate'
    ) {
      window.location.reload();
    } else if (this.pageTemplateName === 'KnBrDraftOrderDetailPageTemplate') {
      this.routingService.goByUrl('carts');
    } else if (this.pageTemplateName === 'KnBrQuoteDetailPageTemplate') {
      this.routingService.goByUrl('quotes');
    } else if (this.pageTemplateName === 'KnBrOrderDetailsPageTemplate') {
      this.routingService.goByUrl('customer-360/orders');
    } else if (this.pageTemplateName === 'KnBrReturnDetailsPageTemplate') {
      this.routingService.goByUrl('customer-360/returns');
    } else {
      this.routingService.goByUrl('');
    }

    this.customerContextService.delete();
  }
  changeMenuState() {
    this.sidebarService.toggleMenuState();
  }

  logout() {
    this.authService.coreLogout();
    // this.routingService.goByUrl('/logout');
    this.newAuth0Service.logOutTheUser()
  }

  ngOnDestroy() {
    this.destory$.next();
    this.destory$.complete();
    this.subscription.unsubscribe();
  }
}